<template>
  <section id="shipper-cutoff-groups-search-section">
    <el-collapse v-model="isOpen">
      <el-collapse-item
        :title="$t('common.search')"
        name="shipper-cutoff-groups-search-section"
        id="shipper-cutoff-groups-search-collapse"
      >
        <el-form
          id="shipper-cutoff-groups-search-section-form"
          class="search-section-form"
          :model="searchForm"
          ref="searchForm"
          label-position="right"
          size="mini"
          inline
          @submit.native.prevent
        >
          <el-row :gutter="10">
            <el-col :span="8">
              <el-form-item
                :label="$t('shipperCutoffGroup.name')"
              >
                <el-input
                  v-model="searchForm.name"
                  v-alphanumeric-validation
                  maxlength="25"
                  clearable
                  @clear="handleSearch"
                  v-on:keyup.enter.native="handleSearch"
                  class="inline-input"
                  ref="filter-name"
                  id="searchForm-name"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="16" class="text-align-end">
              <el-tooltip
                :content="$t('common.search')"
                class="item"
                effect="dark"
                placement="top-start"
              >
                <el-button
                  id="shippers-cutoff-groups-search-section-form-button"
                  class="button-action-default"
                  @click="handleSearch"
                  icon="el-icon-search"
                  size="mini"
                ></el-button>
              </el-tooltip>
            </el-col>
          </el-row>
        </el-form>
      </el-collapse-item>
    </el-collapse>
  </section>
</template>

<script>

import { SHIPPER_CUTOFF_GROUP_SEARCH } from '@/store/actions';

export default {
  name: 'ShipperCutoffGroupsSearchSection',
  data() {
    return {
      activeCollapsibleName: ['shipper-cutoff-groups-search-section'],
      isOpen: ['shipper-cutoff-groups-search-section'],
      searchForm: {
        name: null
      },
    };
  },
  methods: {
    handleSearch() {
      this.$store.dispatch(SHIPPER_CUTOFF_GROUP_SEARCH, this.searchForm);
    }
  },
  mounted() {
    this.handleSearch();
  }
};
</script>
